/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import {CSP_NONCE} from '@angular/core';
import { lib, enc } from 'crypto-js';



platformBrowserDynamic().bootstrapModule(AppModule, {
  providers: [{
    provide: CSP_NONCE,
    useValue: enc.Base64.stringify(lib.WordArray.random(16))
  }]
});
